import React from 'react';
import ReactDOM from 'react-dom';
import { Card, Affix, Button, Icon } from 'antd';
import { addCtnCommonAttribute, sgiCtnBaseFun } from "./SgiCtnComm"
import { convertModuleByGuid } from "./SgiCompComm"
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory'
import { uuid, copy, copyArr } from 'rt-sd-common/sgiCommon/sgiCommon'
import style from './SgiPanel.css';
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { AllCompGUID } from 'rt-sd-common/sgiConstants/SgiCompConstant';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { getConstByKey } from './sgiBaseComp/SgiCommon';
// const TabPane = Tabs.TabPane;
// const Tile = Collapse.Tile;

const noRender = function () {
    return (
        <span style={{ paddingRight: "20px", fontSize: "18px", display: "inline-block", width: "160px" }}>
            <Icon type={"close"} style={{ color: "red" }}></Icon>{"  no-render"}
        </span>
    )
}

class SgiTile extends React.Component {

    //这个暂时不好用 以后在处理
    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);
        this.state = {
            //ctnProps: { style: {} },//form属性
            tileProps: { style: { heigth: '100%', width: '100%' } },//tile全局属性
            tileTitleProps: { style: {} },//tile的title属性
            tileBodyProps: { style: {} },//tile的body属性
            tileItems: [], //面板下控件数组loading
            loading: false,
            toolbarTopItems: [],
            toolbarBottomItems: [],
            tileUUID: undefined,
            isCard: false,
            sonRender: noRender
        };
    }

    /**
     * 根据描述创建form
     * @param {父组件} parentModule 
     * @param {描述} moduleDesc       
     * @param {对象工厂} objFct 
     * @param {make类型} type 
     */
    tile_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        this.state.tileItems = []; //再次渲染的时候清空

        //转换form公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.tileProps);
        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.tileProps, this.state.tileTitleProps, this.state.tileBodyProps, parentModule);
        //设置布局
        //this.setFormCtlLayout(moduleDesc, formProps);
        //绑定事件
        // this.bindEvent(moduleDesc, this.state.tileProps);
        //组装form表单下的控件信息
        // this.fitTileItems(moduleDesc, this.state.tileItems, objFct, type);
    }

    /**
     * 绑定事件
     * @param {*} moduleDesc 
     * @param {*} formProps 
     */
    // bindEvent(moduleDesc, formProps) {

    // }

    /**
     * 根据描述组装子对象
     * @param {描述信息} moduleDesc 
     * @param {属性} formProps 
     */
    // fitTileItems = function (moduleDesc, tileItems, objFct, type) {
    //     this.state.extras = [];
    //     var me = this;
    //     //form下的子节点添加到form组件中
    //     let cldSet = moduleDesc.cldSet;
    //     if (cldSet && cldSet.length && cldSet.length > 0) {
    //         cldSet.forEach((item, index) => {
    //             if (item.desId === AllCompGUID.TOOLBAR) {
    //                 if (item.inTitle) {
    //                     this.state.btnAlg = item.btnAlg || "right";//记录按钮位置
    //                     const itemSons = item.cldSet;
    //                     if (itemSons) {
    //                         itemSons.forEach(son => {
    //                             this.state.extras.push(convertModuleByGuid(this, son, null, objFct, type));
    //                         });
    //                     }
    //                 } else {
    //                     if (!item.tlbAlg || item.tlbAlg == 'top' || item.tlbAlg == 'left') {
    //                         this.state.toolbarTopItems.push(convertModuleByGuid(this, item, null, objFct, type));
    //                     } else {
    //                         this.state.toolbarBottomItems.push(convertModuleByGuid(this, item, null, objFct, type));
    //                     }
    //                 }
    //             } else {
    //                 tileItems.push(convertModuleByGuid(me, item, null, objFct, type));
    //             }
    //         });
    //     }
    // }

    refresh = () => {
        this.loaded = false;
        this.state.tileUUID = uuid(8);
        this.setState({ loading: false });
    }

    // getChildContent() {
    //     return (
    //         <div key={this.state.tileUUID} className={style.body} {...this.state.tileBodyProps}>
    //             {this.state.tileItems}
    //             {this.props.children}
    //         </div>
    //     );
    // }

    getTitle() {
        const isTtl = this.state.isTtl;
        const titleText = this.state.tileTitleProps.title;
        const btnAlg = this.state.btnAlg;
        if (btnAlg === "left") {
            return <div>{isTtl ? <span style={{ marginRight: "10px" }}>{titleText}</span> : null}{this.state.extras}</div>
        } else {
            return isTtl ? titleText : null;
        }
    }

    renderOne(record, index, arr) {
        // 自定义子组件渲染
        const sonRender = this.state.sonRender;
        const { parentModule, moduleDesc, objFct, type } = this.props;
        if (sonRender) {
            return sonRender(this, record, index, arr, objFct);
        } else {
            return noRender();
        }
    }

    renderAll(data) {
        data = data || this.state.data || [];
        return data.map((item, index, arr) => this.renderOne(item, index, arr));
    }

    refreshByData(data) {
        data = data || [];
        this.setState({ data });
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, objFct, type } = this.props;

        if (!this.loaded) {
            //组装属性
            this.tile_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        // 通用渲染前处理，添加自定义样式等
        this.renderBeforeReturn(this.state.tileProps);

        return (
            <div {...this.state.tileProps}>
                {this.state.toolbarTopItems ? this.state.toolbarTopItems : null}
                {this.state.isCard ?
                    <Card title={this.getTitle()}
                        // bordered={!!this.state.tileProps.style.border}
                        bordered={false}
                        size="small"
                        extra={this.state.btnAlg === "left" ? null : this.state.extras}>
                        {/* {this.getChildContent()} */}
                        {this.renderAll()}
                    </Card>
                    :
                    <div style={{ flex: 1, height: '100%', width: '100%' }} >
                        <div className={style.title} {...this.state.tileTitleProps}>
                            <span>{this.state.tileTitleProps.title}</span>
                        </div>
                        {/* {this.getChildContent()} */}
                        {this.renderAll()}
                    </div>
                }
                {this.state.toolbarBottomItems ? this.state.toolbarBottomItems : null}
            </div >
        )
    }



    /**
     * 属性转换
     * @param {描述信息} moduleDesc 
     * @param {属性} tileProps 
     */
    AddAttribute = function (moduleDesc, tileProps, tileTitleProps, tileBodyProps, parentModule) {
        var type;
        if (parentModule && parentModule.state && parentModule.state.itemTileType) {
            type = parentModule.state.itemTileType;
        }

        var text = tileProps.te;//公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
        if (text) tileTitleProps.title = text;

        var ttlAlgn = moduleDesc.ttlAlgn; //form标题对齐方式
        if (ttlAlgn) tileTitleProps.style['text-align'] = ttlAlgn;

        var isTtl = moduleDesc.isTtl; //form是否显示标题
        if (!isTtl) {
            tileTitleProps.style.display = "none";
        } else {
            tileTitleProps.style.display = undefined;
        }
        this.state.isTtl = !!isTtl;

        // 是否card样式
        const isCard = moduleDesc.isCard;
        this.state.isCard = !!isCard;

        var isScl = moduleDesc.isScl; //form是否可以滚动??没实现
        //if(isScl) tileBodyProps.style.display

        if (type === 'tabs' || type == 'cos') {
            tileTitleProps.style.display = "none";
        }

        // 取data
        const bdInst = getConstByKey(this, moduleDesc.bdInst);
        this.state.insName = bdInst;
        const { objFct } = this.props;
        if (bdInst && objFct) {
            this.state.data = objFct.get(bdInst) || [];
        }

        // 自定义子组件渲染方法
        let sonRender = moduleDesc.sonRender;
        let $sonRender;
        if (sonRender) {
            try {
                $sonRender = new Function("module", "record", "index", "array", "objFct", sonRender);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            this.state.sonRender = $sonRender;
        }
    }

}
//给类添加公共方法
Object.assign(SgiTile.prototype, sgiCtnBaseFun);
export { SgiTile };
export default SgiTile;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTile.js